/* eslint-disable no-console */
import { ToastErrorHandler } from "@app/components/core/ToastErrorHandler/ToastErrorHandler"
import { MassageReservationTimer } from "@app/components/MassageReservationTimer/MassageReservationTimer"
import { NavigationHandler } from "@app/components/navigation/NavigationHandler"
import RootNavigation from "@app/components/navigation/RootNavigation"
import { setAccounts, setHtgGuestData, setLanguage, setTransponder } from "@app/store/actions/coreActions"
import { useRaiseError } from "@app/store/actions/errorActions"
import { addPriceAction, useSetShoppingCart } from "@app/store/actions/orderActions"
import { useGetLocation } from "@app/store/service/cmsService"
import { useCheckScanCode, useGetBankAccounts, useGetFunnel, useGetRelation, useGetTransponder } from "@app/store/service/connectorService"
import { appStore } from "@app/store/store"
import { faSpinner } from "@fortawesome/free-solid-svg-icons/faSpinner"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { KioskBridge } from "@tecreation/bird5-kiosk-bridge"
import { ModalHandler, ToastHandler } from "@tecreation/funnel-components"
import { useSelector } from "@tecreation/js-state-react"
import { solveChallenge } from "@tecreation/pow-solver"
import { domAnimation, LazyMotion } from "framer-motion"
import { useCallback, useEffect, useState } from "react"
import { MemoryRouter } from "react-router"
import { Loader } from "./components/core/Loader/Loader"
import { refreshToken } from "./store/service/authService"
import { ADRESS_TYPES, IframeMessages } from "./utils/constants"
import localStore from "./utils/localStore"

export default function App({ locationId, language, kiosk, source, onSiteLounger }) {
	const funnelToken = useSelector(state => state.settings.funnelToken)
	const internalRelation = useSelector(state => state.core.relation)
	const [checkScancode, _data] = useCheckScanCode()
	const [loaded, setLoaded] = useState(false)
	const [page, setPage] = useState(undefined)
	const [loadUserData, setloadUserData] = useState(false)

	const raiseError = useRaiseError()
	const setShoppingCart = useSetShoppingCart()
	const { data: loadedfunnel } = useGetFunnel({ funnelToken: funnelToken }, { skip: funnelToken === undefined })
	const { data: location } = useGetLocation()
	const { data: transponder } = useGetTransponder(null, { skip: !loadUserData })
	const { data: account } = useGetBankAccounts(null, { skip: !loadUserData })
	const relationLoggedIn = useSelector(state => state.core.flow == "relation")
	const { data: relation, error: relationError, isLoading: relationLoading } = useGetRelation(undefined, { skip: !relationLoggedIn })

	// console.log(appStore.getState())
	const handleParentMessages = useCallback(event => {
		if (!appStore.get("core.kioskMode") && !appStore.get("core.employeeMode") && !appStore.get("core.onSiteMode")) {
			const split = event.data.split(";")
			const message = split[0]
			const data = split.length > 1 ? split[1] : undefined
			if (message === IframeMessages.returnShoppingCartTime) {
				if (data !== undefined) {
					let date = new Date(data)
					if (date < new Date()) {
						window.parent.postMessage(IframeMessages.setShoppingCart + ";" + JSON.stringify([]), "*")
					} else {
						window.parent.postMessage(IframeMessages.getShoppingCart, "*")
					}
				} else {
					window.parent.postMessage(IframeMessages.setShoppingCart + ";" + JSON.stringify([]), "*")
				}
			} else if (message === IframeMessages.returnShoppingCart) {
				try {
					let shoppingCart = JSON.parse(data || "[]")
					setShoppingCart(shoppingCart || [])
				} catch {
					console.log("error in parent message")
				}
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (window.self !== window.top) {
			window.addEventListener("message", handleParentMessages)
			window.parent.postMessage(IframeMessages.getShoppingCartTime, "*")

			KioskBridge.onEvent("error", err => {
				console.log("error from kiosk")
				console.log(err)
			})
		}

		const params = new URLSearchParams(window.location.search)
		const resetPasswordToken = params.get("resetPasswordToken")
		const code = params.get("code")
		const amazonCheckoutSessionId = params.get("amazonCheckoutSessionId")
		const orderNumber = params.get("orderNumber")
		const success = params.get("success")
		const webToken = params.get("webToken")
		const aborted = params.get("aborted")
		const verificationToken = params.get("verificationToken")
		const relationPaymentToken = params.get("relationPaymentToken")
		const guestData64 = params.get("guestData")
		const employee = params.get("employee") ? (params.get("employee") == "true" ? true : false) : false
		const ticketIds = params.get("ticketIds") ? params.get("ticketIds").split(",") : undefined

		let page = params.get("view")
		let formattedOrder = null
		let priceActions = null

		if (resetPasswordToken) {
			page = "new-password"
		}
		if (verificationToken) {
			page = "confirm-account"
		}
		if ((orderNumber || amazonCheckoutSessionId) && success == "false") {
			page = "order-failed"
			if (aborted == "true") {
				page = undefined
			}
		} else if ((orderNumber || amazonCheckoutSessionId) && success == "true") {
			page = "order-succeed"
		}

		if (amazonCheckoutSessionId) {
			formattedOrder = localStore.getItem("formattedOrder")
			priceActions = localStore.getItem("priceActions")
		}

		if (relationPaymentToken && success) {
			page = "myParadise"
		}
		if (ticketIds && ticketIds.length) {
			let handler = ticketIds.map(e => {
				return checkScancode({
					scanCode: e,
				}).unwrap()
			})

			Promise.all(handler)
				.then(e => {
					e.forEach(addPriceAction)
				})
				.catch(_e => {
					raiseError(new Error("cant validate ticket codes"))
				})
		}

		if (guestData64) {
			try {
				const decoded = atob(guestData64)
				try {
					const guestDataJson = JSON.parse(decoded)
					// if (guestDataJson.language) {
					// 	cmsApiSlice.utils.refresh()
					// 	locationCmsApiSlice.utils.refresh()
					// }

					setLanguage(guestDataJson.language || language || "de")
					setHtgGuestData(guestDataJson)
				} catch (e) {
					setHtgGuestData({})
					raiseError(e)
				}
			} catch (e) {
				setHtgGuestData({})
				raiseError(e)
			}
		} else {
			if (language) {
				setLanguage(language)
			}
		}

		if (employee) {
			page = "employeeFunnel"
		}

		if (kiosk && !page) {
			page = "kiosk-entrance"
		}

		if (onSiteLounger) {
			page = "on-site-lounger-booking"
		}

		const prepareTimePlanning = params.get("prepareTimePlanning") === "true" ? true : undefined

		setPage(page)
		appStore.set(state => ({
			core: {
				...state.core,
				locationId: locationId,
				resetPasswordToken,
				verificationToken,
				verificationCode: code,
				orderNumber,
				webToken,
				amazonCheckoutSessionId,
				kioskMode: kiosk,
				employeeMode: employee,
				onSiteMode: onSiteLounger,
				funnelToken: funnelToken,
				frameSource: source,
				prepareTimePlanning,
				forceCardLock: params.get("forceCardLock") === "true" ? true : false,
				relationPaymentToken,
				returnStatusPayment: success,
			},
			order: {
				...state.order,
				formattedOrder: formattedOrder ? JSON.parse(formattedOrder) : null,
				priceActions: priceActions ? JSON.parse(priceActions) : [],
				selectedDay: page === "employeeFunnel" || onSiteLounger ? { date: new Date().toISOString().slice(0, 10), dateObj: new Date() } : undefined,
			},
		}))

		return () => {
			window.removeEventListener("message", handleParentMessages)
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	useEffect(() => {
		if (loadedfunnel && !relationLoading) {
			appStore.set(state => ({
				core: {
					...state.core,
					funnel: loadedfunnel,
				},
			}))
			setLoaded(true)
		}
	}, [loadedfunnel, relationLoading])

	useEffect(() => {
		if (location) {
			appStore.set(state => ({
				core: {
					...state.core,
					location: location,
				},
			}))
		}
	}, [location])

	useEffect(() => {
		if (relationError) return
		if (relation || (internalRelation && !internalRelation.guest)) {
			setloadUserData(true)
			appStore.set(state => ({
				core: {
					...state.core,
					relation: internalRelation || relation,
				},
			}))
		}

		if (!appStore.get("core.invoiceAddress")) {
			const invoiceAddress = internalRelation?.addresses?.find(e => e.addressTypeId === ADRESS_TYPES.INVOICE)

			appStore.set("core.invoiceAddress", invoiceAddress && invoiceAddress.firstName && invoiceAddress.lastName ? { ...invoiceAddress } : undefined)
			appStore.set("core.deliveryAddress", undefined)
		}
	}, [relation, internalRelation, relationError])

	useEffect(() => {
		if (transponder) {
			setTransponder(transponder)
		}
		if (account && Array.isArray(account)) {
			let thermencardAccount = account.find(e => e.isEmployee === false)
			let employeePoints = account.find(e => e.isEmployee === true && e.blocked == false)
			setAccounts(thermencardAccount, employeePoints)
		}
	}, [transponder, account])

	if (!loaded) {
		return (
			<div className="w-100 h-100 flex flex-center f00">
				<FontAwesomeIcon icon={faSpinner} spin />
			</div>
		)
	}

	return (
		<LazyMotion features={domAnimation}>
			<MemoryRouter initialEntries={[page ? "/" + page : "/"]}>
				<NavigationHandler>
					<ToastHandler>
						<ModalHandler>
							<MassageReservationTimer />
							<ToastErrorHandler />
							<div id="content" className="h-100">
								<RootNavigation />
							</div>
						</ModalHandler>
					</ToastHandler>
				</NavigationHandler>
			</MemoryRouter>
		</LazyMotion>
	)
}

export const PowChallengeSolver = ({ children }) => {
	const [refreshTry, setRefreshTry] = useState(false)
	const accessToken = useSelector(state => state.core.accessToken)
	const raiseError = useRaiseError()

	useEffect(() => {
		const refresh = async () => {
			let result = undefined
			const localStoreFlow = localStore.getItem("flow")
			if (localStoreFlow == "relation") {
				appStore.set("core.flow", "relation")
				result = await refreshToken()
				if (result?.succeed) {
					window.parent.postMessage(IframeMessages.setRelationSessionToken + ";" + 123, "*")
					appStore.set("core.accessToken", result.data.token)
					return
				}
			} else {
				appStore.set("core.flow", "guest")
			}

			setRefreshTry(true)
		}

		refresh()
	}, [])

	useEffect(() => {
		const init = async () => {
			try {
				localStore.setItem("flow", "guest")
				const token = await solveChallenge("/")
				appStore.set("core.accessToken", token)
			} catch (e) {
				console.error("Error logging in after proof of work:", e)
				raiseError(e, undefined, true)
			}
		}
		//only call init if refresh was not sucessfull
		if (refreshTry) {
			init()
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [refreshTry])

	if (accessToken) {
		return children
	}

	return (
		<div className="w-100 h-100 flex flex-center f00">
			<Loader show />
		</div>
	)
}
